import { render, staticRenderFns } from "./ResponsibleListAddNew.vue?vue&type=template&id=1080e8cd&"
import script from "./ResponsibleListAddNew.vue?vue&type=script&lang=js&"
export * from "./ResponsibleListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports